import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RestaurantInfoService } from '../appServices/restaurant-info.service';
import { TenantResolver } from './tenant.resolver';

@Injectable({
    providedIn: 'root'
})
export class RestaurantBasicInfoStorage {
    restaurantBasicInfo = new BehaviorSubject<any>(null);
    constructor(
        private restaurantInfoService: RestaurantInfoService,
        private _tenantResolver: TenantResolver) {
        this.getBasicInfo();
     }

    getBasicInfo() {
       
        if (!sessionStorage.getItem("basic-info")) {
            this.setRestaurantBasicInfoFromApi();
        } else {
            this.restaurantBasicInfo.next(JSON.parse(sessionStorage.getItem("basic-info")));
        }
    }

    setRestaurantBasicInfoFromApi() {
        const tenantName = this._tenantResolver.getTenantName();
        if(tenantName) {
            this.restaurantInfoService.getBasicInfo().subscribe(res => {
                sessionStorage.setItem("basic-info", JSON.stringify(res));
                this.restaurantBasicInfo.next(res);
            })
        }
       
    }

}